<template>
    <div class="flex-row align-items-center login">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="4">
                    <b-card no-body class="p-2">
                        <b-card-body>
                            <h2 class="mb-4">Login</h2>
                            <b-alert :show="error !=null" variant="danger">
                                {{error}}
                            </b-alert>
                            <b-form @submit="login()">
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                                    <b-form-input type="text" placeholder="Email" v-model="email" :state="valid(email)"></b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-4">
                                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                                    <b-form-input type="password" class="form-control" placeholder="Password" v-model="password" :state="valid(password)"></b-form-input>
                                </b-input-group>

                                <b-button type="submit" block variant="primary" class="px-4 mb-2" @click="login"><font-awesome-icon v-if="busy" icon="spinner" pulse /> <span v-if="!busy">Login</span></b-button>

                            </b-form>

                            <b-row class="links">
                                <b-col md="12" class="text-center mb-2">
                                    <router-link :to="{name: 'forgotPassword'}">Forgot Password?</router-link>
                                </b-col>

                                <b-col class="text-center">
                                    Don't have an account? <router-link :to="{name: 'register'}">Create one</router-link>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      email: "",
      password: "",
      redirect_url: "https://prompts-dev.gmvoices.com/purecloud/authorize/",
      errors: null,
      error: null,
      submitted: false,
      busy: false
    }
  },

    methods: {
        valid (field) {
            if (this.error === null) {
                return null
            }

            if (field === '') {
                return false
            }

            return true
        },
        async login(e) {
            e.preventDefault()

            this.busy = true

            try {
            
                if (!this.email || !this.password) {
                    return this.error = 'Missing your email or password'
                }

                var data = {
                    client_id: 2,
                    client_secret: "iHj4pZofKqCmTtAQtMLHzU14l4GNUVNKUOvTtqti",
                    grant_type: "password",
                    scope: "*",
                    username: this.email,
                    password: this.password
                };

                const res = await this.axios.post(window.location.protocol + "//" + window.location.host +"/oauth/token", data)

                if (!res.data.access_token) {
                    if (res.data.action && res.data.action === 'reset_password') {
                        this.$router.push({path: '/reset-password', query: {temp: true}});
                    }

                    this.errors = {message: 'There was an issue logging you in'}
                } else {
                    this.$auth.setToken(res.data.access_token, (res.data.expires_in * 1000) + Date.now())

                    this.$store.dispatch('tag/fetch')
                    this.$store.dispatch('talent/fetch')

                    if (!!this.$store.state.project.current) {
                        try {
                            const project = await this.$store.dispatch('project/read', this.$store.state.project.current)

                            if (project.status !== 'draft') {
                                this.$store.commit('project/removeCurrent')
                                this.$store.commit('prompt/clear')
                            }

                        } catch (ex) {
                            this.$store.commit('project/removeCurrent')
                            this.$store.commit('prompt/clear')
                        }                        
                    }

                    this.$router.push({path: '/projects/list', query: this.$route.query})
                    //Check info on user.
                }
            } catch (ex) {
                if (ex.response && ex.response.data && ex.response.data.errors) {
                    this.errors = ex.response.data.errors
                }
                
                console.log(ex)
                this.error = ex.response.data.message

                this.busy = false
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// prompts/views/pages/Login.vue